import gql from "graphql-tag";
const NAVIGATION_MENU = gql`
	query {
		navigationMenu {
			items {
				id
				name
				isGroup
				position
				parentId
				icon
				url
				contactNavigationMenu {
					id
					position
					isHidden
					isFavorite
				}
			}
		}
	}
`;
const NAVIGATION_MENU_FOR_EDIT = gql`
	query {
		navigationMenuForEdit {
			items {
				id
				name
				isGroup
				isDeleted
				position
				parentId
				icon
				url
				isSystem
				roles {
					id
					name
				}
			}
		}
	}
`;
const ADD_OR_EDIT_NAVIGATION_MENU = gql`
	mutation ($inputs: [NavigationMenuInput!]!, $deletedItems: [UUID]) {
		addOrEditNavigationMenu(inputs: $inputs, deletedItems: $deletedItems) {
			id
		}
	}
`;
gql`
	mutation ($inputs: [ContactNavigationMenuInput!]!) {
		addOrEditMyNavigationMenu(inputs: $inputs) {
			id
		}
	}
`;
export {
  ADD_OR_EDIT_NAVIGATION_MENU,
  NAVIGATION_MENU,
  NAVIGATION_MENU_FOR_EDIT
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
